export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_professional-97a4e8fdfd7ed3302ff44a3e25af2c70.jpg";